import { z } from 'zod';
import { errorCodeSchema, fieldErrorSchema } from './api-error.js';
import { paginationMetaSchema } from './pagination.js';
import { localeSchema } from './primitives.js';
/** Fields shared by every JSON response. */
export const responseBaseSchema = z.object({
    success: z.boolean(),
    requestId: z.string(),
    timestamp: z.iso.datetime({ offset: true }),
    locale: localeSchema,
});
/** Wraps a payload schema in the standard success envelope. */
export const successResponseSchema = (data) => responseBaseSchema.extend({
    success: z.literal(true),
    data,
    meta: paginationMetaSchema.nullable(),
});
export const apiErrorBodySchema = z.object({
    code: errorCodeSchema,
    message: z.string(),
    fieldErrors: z.array(fieldErrorSchema).optional(),
    /** Values for the translated message, e.g. { limit: "10000.0000" }. */
    params: z.record(z.string(), z.string()).optional(),
});
export const errorResponseSchema = responseBaseSchema.extend({
    success: z.literal(false),
    error: apiErrorBodySchema,
    statusCode: z.number().int(),
    path: z.string(),
});
export function isSuccessResponse(response) {
    return response.success;
}
//# sourceMappingURL=envelope.js.map